// Legal pages content for Grupo Ritual (Spanish market — RGPD / LOPDGDD).
// Official company data provided by the client.
export const COMPANY = {
  name: "Ritual Coffee and Restaurant S.L.",
  cif: "B56388192",
  address: "Calle Ravanell 1, Bajo, 46980 Paterna (Valencia), España",
  email: "info@gruporitual.com",
  phone: "+34 960 419 855",
  registry: "PENDIENTE",
  site: "gruporitual.com",
};

const id = (es, en, va) => ({ es, en, va });

// Each document: slug, title (multilingual), updated date, sections [{ h, p:[...] }].
// Legal body is written in Spanish (official language for these documents in Spain).
export const LEGAL_DOCS = {
  privacidad: {
    slug: "privacidad",
    title: id("Política de Privacidad", "Privacy Policy", "Política de Privacitat"),
    updated: "2026-06",
    sections: [
      {
        h: "1. Responsable del tratamiento",
        p: [
          `Titular: ${COMPANY.name} (en adelante, "Grupo Ritual").`,
          `CIF: ${COMPANY.cif}.`,
          `Domicilio fiscal: ${COMPANY.address}.`,
          `Email de contacto en materia de protección de datos: ${COMPANY.email}.`,
          `Teléfono: ${COMPANY.phone}.`,
          `Datos registrales: ${COMPANY.registry}.`,
        ],
      },
      {
        h: "2. Datos que tratamos y finalidad",
        p: [
          "Tratamos los datos que nos facilitas a través de los formularios de la web (compra en tienda, solicitud de reserva, suscripción a la newsletter, lista de espera y contacto).",
          "Datos de pedido (nombre, email, teléfono, dirección de envío): para gestionar y entregar tu pedido, enviar confirmaciones y atender el servicio postventa.",
          "Datos de reserva (nombre, teléfono, email, fecha, hora y número de comensales): para gestionar tu solicitud de reserva en nuestros locales.",
          "Email de newsletter y lista de espera: para enviarte novedades, lanzamientos y comunicaciones comerciales de Grupo Ritual, siempre que nos hayas dado tu consentimiento.",
        ],
      },
      {
        h: "3. Legitimación",
        p: [
          "La base legal del tratamiento es la ejecución de un contrato (compras y reservas), el consentimiento del interesado (newsletter y lista de espera) y el interés legítimo en la mejora de nuestros servicios.",
          "Puedes retirar tu consentimiento en cualquier momento sin que ello afecte a la licitud del tratamiento previo.",
        ],
      },
      {
        h: "4. Conservación de los datos",
        p: [
          "Conservaremos tus datos mientras se mantenga la relación comercial y, posteriormente, durante los plazos legalmente exigidos (fiscales, contables y de garantía). Los datos de marketing se conservarán hasta que solicites la baja.",
        ],
      },
      {
        h: "5. Destinatarios y encargados de tratamiento",
        p: [
          "No cedemos tus datos a terceros salvo obligación legal. Para prestar el servicio utilizamos proveedores que actúan como encargados de tratamiento: pasarela de pago (Stripe), proveedor de correo electrónico (Google Workspace) y proveedores de alojamiento, con los que mantenemos los correspondientes contratos de encargo.",
        ],
      },
      {
        h: "6. Tus derechos",
        p: [
          "Puedes ejercer los derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad enviando un email a " + COMPANY.email + ", indicando el derecho que deseas ejercer.",
          "Asimismo, tienes derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es) si consideras que el tratamiento no se ajusta a la normativa vigente.",
        ],
      },
    ],
  },

  cookies: {
    slug: "cookies",
    title: id("Política de Cookies", "Cookie Policy", "Política de Cookies"),
    updated: "2026-06",
    sections: [
      {
        h: "1. ¿Qué son las cookies?",
        p: [
          "Una cookie es un pequeño archivo de texto que se almacena en tu navegador cuando visitas nuestra web. Permite recordar tus preferencias y mejorar tu experiencia de navegación.",
        ],
      },
      {
        h: "2. Tipos de cookies que utilizamos",
        p: [
          "Cookies técnicas (necesarias): imprescindibles para el funcionamiento de la web, el carrito de compra y el proceso de pago. No requieren consentimiento.",
          "Cookies de preferencias: recuerdan el idioma seleccionado (almacenado localmente en tu navegador).",
          "Cookies analíticas: nos ayudan a entender cómo se utiliza la web de forma agregada y anónima, para mejorarla.",
        ],
      },
      {
        h: "3. Gestión de cookies",
        p: [
          "Puedes configurar o desactivar las cookies desde la configuración de tu navegador. Ten en cuenta que desactivar las cookies técnicas puede afectar al correcto funcionamiento de la tienda.",
          `Para cualquier duda sobre nuestra política de cookies, escríbenos a ${COMPANY.email}.`,
        ],
      },
    ],
  },

  "aviso-legal": {
    slug: "aviso-legal",
    title: id("Aviso Legal", "Legal Notice", "Avís Legal"),
    updated: "2026-06",
    sections: [
      {
        h: "1. Datos identificativos",
        p: [
          `En cumplimiento de la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de los siguientes datos:`,
          `Titular: ${COMPANY.name}.`,
          `CIF: ${COMPANY.cif}.`,
          `Domicilio: ${COMPANY.address}.`,
          `Email: ${COMPANY.email}. Teléfono: ${COMPANY.phone}.`,
          `Datos registrales: ${COMPANY.registry}.`,
        ],
      },
      {
        h: "2. Objeto",
        p: [
          `El presente Aviso Legal regula el uso del sitio web ${COMPANY.site}, propiedad de ${COMPANY.name}. La navegación por la web atribuye la condición de usuario e implica la aceptación de las presentes condiciones.`,
        ],
      },
      {
        h: "3. Propiedad intelectual e industrial",
        p: [
          "Todos los contenidos del sitio web (textos, fotografías, gráficos, imágenes, marcas y logotipos) son titularidad de Grupo Ritual o de terceros que han autorizado su uso. Queda prohibida su reproducción total o parcial sin autorización expresa.",
        ],
      },
      {
        h: "4. Responsabilidad",
        p: [
          "Grupo Ritual no se hace responsable del mal uso que se realice de los contenidos de la web, siendo exclusiva responsabilidad de la persona que accede a ellos o los utiliza.",
        ],
      },
    ],
  },

  "condiciones-compra": {
    slug: "condiciones-compra",
    title: id("Condiciones de Compra", "Terms of Purchase", "Condicions de Compra"),
    updated: "2026-06",
    sections: [
      {
        h: "1. Información general",
        p: [
          `Las presentes condiciones regulan la compra de productos y experiencias a través de la tienda online de ${COMPANY.name}.`,
          "Los precios mostrados incluyen el IVA aplicable. Grupo Ritual se reserva el derecho a modificar los precios en cualquier momento; el precio aplicable será el vigente en el momento de la compra.",
        ],
      },
      {
        h: "2. Proceso de compra y pago",
        p: [
          "La compra se formaliza al completar el proceso de pago. Los pagos se procesan de forma segura a través de la pasarela Stripe.",
          "Una vez confirmado el pago, recibirás un email de confirmación con el número de pedido y el detalle de tu compra.",
        ],
      },
      {
        h: "3. Tarjetas regalo",
        p: [
          "Las tarjetas regalo son válidas en nuestros locales y en la tienda online durante 365 días desde su emisión. Pueden canjearse total o parcialmente y no son reembolsables ni canjeables por dinero en efectivo.",
        ],
      },
      {
        h: "4. Experiencias y talleres",
        p: [
          "La compra de talleres y catas da derecho a una plaza en la fecha acordada. Las condiciones de cambio o cancelación se comunicarán al confirmar la reserva de la plaza.",
        ],
      },
    ],
  },

  envios: {
    slug: "envios",
    title: id("Política de Envíos", "Shipping Policy", "Política d'Enviaments"),
    updated: "2026-06",
    sections: [
      {
        h: "1. Ámbito de envío",
        p: [
          "Realizamos envíos a la España peninsular. Para envíos a Baleares, Canarias, Ceuta, Melilla u otros destinos, contacta con nosotros antes de realizar el pedido.",
        ],
      },
      {
        h: "2. Plazos de entrega",
        p: [
          "Los pedidos se preparan en un plazo de 24-72 horas laborables. El plazo de entrega estimado es de 2 a 5 días laborables desde la confirmación del pedido, salvo incidencias ajenas a Grupo Ritual.",
          "El café se tuesta y envía lo más fresco posible para garantizar la máxima calidad en taza.",
        ],
      },
      {
        h: "3. Gastos de envío",
        p: [
          "Los gastos de envío, si los hubiera, se mostrarán claramente antes de finalizar la compra.",
          `Para cualquier consulta sobre el estado de tu pedido, escríbenos a ${COMPANY.email} indicando tu número de pedido.`,
        ],
      },
      {
        h: "4. Productos digitales",
        p: [
          "Las tarjetas regalo digitales se entregan por email de forma inmediata tras la confirmación del pago, sin gastos de envío.",
        ],
      },
    ],
  },

  devoluciones: {
    slug: "devoluciones",
    title: id("Política de Devoluciones", "Returns Policy", "Política de Devolucions"),
    updated: "2026-06",
    sections: [
      {
        h: "1. Derecho de desistimiento",
        p: [
          "Dispones de 14 días naturales desde la recepción del pedido para ejercer el derecho de desistimiento, sin necesidad de justificación, conforme a la normativa de consumidores y usuarios.",
        ],
      },
      {
        h: "2. Excepciones",
        p: [
          "Por motivos de higiene y conservación, el café en grano o molido que haya sido abierto no admite devolución. Tampoco se admiten devoluciones de tarjetas regalo ni de plazas de talleres y catas ya disfrutadas.",
        ],
      },
      {
        h: "3. Cómo solicitar una devolución",
        p: [
          `Para iniciar una devolución, escríbenos a ${COMPANY.email} indicando tu número de pedido y el motivo. Te facilitaremos las instrucciones para el retorno del producto.`,
          "Una vez recibido y verificado el producto, procederemos al reembolso por el mismo medio de pago utilizado en la compra, en un plazo máximo de 14 días.",
        ],
      },
      {
        h: "4. Productos defectuosos",
        p: [
          "Si recibes un producto defectuoso o dañado, contáctanos en un plazo de 48 horas desde la recepción adjuntando una fotografía. Asumiremos los gastos de la devolución y te enviaremos un nuevo producto o realizaremos el reembolso.",
        ],
      },
    ],
  },
};

// Footer link order
export const LEGAL_LINKS = [
  { slug: "privacidad", label: id("Política de Privacidad", "Privacy Policy", "Política de Privacitat") },
  { slug: "cookies", label: id("Política de Cookies", "Cookie Policy", "Política de Cookies") },
  { slug: "aviso-legal", label: id("Aviso Legal", "Legal Notice", "Avís Legal") },
  { slug: "condiciones-compra", label: id("Condiciones de Compra", "Terms of Purchase", "Condicions de Compra") },
  { slug: "envios", label: id("Política de Envíos", "Shipping Policy", "Política d'Enviaments") },
  { slug: "devoluciones", label: id("Política de Devoluciones", "Returns Policy", "Política de Devolucions") },
];
